import { SpotEntityMapper } from './entityMapper'
import { Spot2 as Spot, PaginateSpots, Spot2, SpotAssets } from '~/models/Spot'
import { SpotRepository } from './repository'
import Media from '~/models/Media'
import { Page } from '~/models/PaginatedItems'
import { PlaceClassification } from '~/models/Place'
export class SpotService {
	repository: any
	constructor(repository?: any) {
		this.repository = repository
	}

	async getSpot(spotId: string): Promise<Spot> {
		const res = await this.repository.getSpot(spotId)
		const { data } = res
		const spot = SpotEntityMapper.toSpot(data)
		return spot
	}

	async obtainSpots(destinationId: string, categoryId: string | null): Promise<PaginateSpots> {
		const res = await this.repository.getSpots({
			destinationId,
			categoryId,
			page: 0,
		})

		const { data } = res
		const paginatedSpots = SpotEntityMapper.toPaginatedSpots(data)
		return paginatedSpots
	}

	setExperiences(
		spot: Spot,
		experiences?: Spot[] | undefined,
		count?: number,
		nextPage?: number
	): void {
		spot.experiences = experiences
		spot.experiencesCount = count
		spot.experiencesNextPage = nextPage
	}

	pushSpotExperiences(spot: Spot, spotExperiences?: Spot[] | undefined, nextPage?: number): void {
		spotExperiences?.forEach((spotExperience: Spot) => {
			const indexed = spot.experiences?.find(
				(indexedSpotExperience: any) => indexedSpotExperience.id === spotExperience.id
			)
			if (!indexed) {
				spot.experiences?.push(spotExperience)
			}
		})
		spot.experiencesNextPage = nextPage
	}

	setNearbySpots(spot: Spot, nearbySpots?: Spot[] | undefined, nextPage?: number): void {
		spot.nearbySpots = nearbySpots
		spot.nearbySpotsNextPage = nextPage
	}

	pushNearbySpots(spot: Spot, nearbySpots?: Spot[] | undefined, nextPage?: number): void {
		nearbySpots?.forEach((nearbySpot: Spot) => {
			const indexed = spot.nearbySpots?.find(
				(indexedNearbySpot: Spot) => indexedNearbySpot.id === nearbySpot.id
			)
			if (!indexed) {
				spot.nearbySpots?.push(nearbySpot)
			}
		})
		spot.nearbySpotsNextPage = nextPage
	}

	async find(placeId: string): Promise<Spot> {
		const res = await this.repository.find(placeId)
		const { data } = res
		const spot = SpotEntityMapper.toSpot(data)
		return spot
	}

	static async find(placeId: string): Promise<Spot> {
		return await SpotRepository.find(placeId)
	}

	static async getMedias(id: string, page: number, pageSize: number): Promise<Page<Media>> {
		return await SpotRepository.getMedias(id, page, pageSize)
	}

	static async getSpot(spotId: string): Promise<Spot2> {
		return await SpotRepository.getSpot(spotId)
	}

	static async createSpotFromPlace(placeId: string): Promise<Spot2> {
		return await SpotRepository.createSpotFromPlace(placeId)
	}

	static async getAssets(spotId: string): Promise<SpotAssets> {
		return await SpotRepository.getAssets(spotId)
	}

	static async getNearbySpots(
		latitude: number,
		longitude: number,
		radius: number,
		page: number,
		pageSize: number
	): Promise<PaginateSpots> {
		return await SpotRepository.getNearbySpots(latitude, longitude, radius, page, pageSize)
	}

	static mapIcon(type: string): string {
		const iconsCorrelation: Record<string, string> = {
			accommodation: 'bed',
			drink: 'drink',
			food: 'food',
			airport: 'airplane',
			culture: 'culture',
			outdoorLocation: 'mountain',
			service: 'locatedBuilding',
			shopping: 'shopping',
			transport: 'bus',
			touristAttraction: 'camera',
			beach: 'beach',
		}
		return iconsCorrelation[type]
	}

	static translationsByType(type: PlaceClassification): string {
		const translations = {
			accommodation: 'common_categories_accommodations',
			drink: 'common_categories_drink',
			food: 'booking_type_food',
			airport: 'common_categories_airports',
			culture: 'common_categories_culture',
			outdoorLocation: 'common_categories_outdoorLocations',
			service: 'common_categories_services',
			shopping: 'destination_typeofdestination_shop',
			transport: 'Booking_Type_Transport',
			touristAttraction: 'common_categories_POI',
			beach: 'destination_title_categories_beaches',
		}
		return translations[type]
	}
}
